import script from "./CreateSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSlider.vue?vue&type=script&setup=true&lang=js"

import "./CreateSlider.vue?vue&type=style&index=0&id=336d834a&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336d834a"]])

export default __exports__